import { DirectorySubcategoryList } from './DirectorySubcategoryList';
import { DirectorySubcategoryEdit } from './DirectorySubcategoryEdit';
import { DirectorySubcategoryCreate } from './DirectorySubcategoryCreate';
import SubCategoryIcon from '@mui/icons-material/Bookmark';

export default {
    list: DirectorySubcategoryList,
    edit: DirectorySubcategoryEdit,
    create: DirectorySubcategoryCreate,
    icon: SubCategoryIcon,
};


